import { LEFT_BAR_TABS } from 'gcs-common/constants/uiFlags';
import { getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getLeftBarTab } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import NewChat from '../NewChat/NewChat';
import Settings from '../Settings/Settings';
import Sidebar from '../Sidebar/Sidebar';

const LeftBar = () => {
  const currentTab = useSelector(getLeftBarTab);
  const isAgent = useSelector(getIsAgent);

  const bar = useMemo(() => {
    switch (currentTab) {
      case LEFT_BAR_TABS.PROFILE:
        return <Settings dark={isAgent} />;
      case LEFT_BAR_TABS.NEW_CHAT:
      case LEFT_BAR_TABS.NEW_GROUP_CHAT:
        return <NewChat />;
      default:
        return <Sidebar />;
    }
  }, [currentTab, isAgent]);

  return <div className="flex h-full border-0 border-neutral-7 border-r border-solid bg-white">{bar}</div>;
};

export default LeftBar;
